import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HistoryListComponent } from '@shared/components/history-list/history-list.component';
import { UserTransactionHistoryResponse } from '../../user.model';

@Component({
  selector: 'user-history',
  imports: [HistoryListComponent],
  templateUrl: './user-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserHistoryComponent {
  readonly history = input<UserTransactionHistoryResponse[]>([]);
}
